import {Component, OnInit, input} from '@angular/core';
import {Observable} from 'rxjs';
import {Store} from '@ngrx/store';


import * as fromProfile from '../store/profile.reducers';
import * as fromApp from '../../store/app.reducers';
import * as ProfileAction from '../store/profile.actions';

@Component({
    selector: 'app-audit-placeholder',
    templateUrl: './audit-placeholder.component.html',
    styleUrls: ['./audit-placeholder.component.scss'],
    standalone: false
})
export class AuditPlaceholderComponent implements OnInit {

  readonly name = input(undefined);
  readonly type = input(undefined);
  profileState: Observable<fromProfile.State>;

  constructor(
    private store: Store<fromApp.AppState>
  ) { }

  setExampleStatus(status: boolean) {
    this.store.dispatch(
      new ProfileAction.SetAuditBoxExampleStatus({
        boxName: this.name(),
        status: status
      })
    );
  }

  ngOnInit() {
    this.profileState = this.store.select('profile');
  }

}
